import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Proceso',
    href: '#proceso'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl" data-id="element-162" data-mp="4lqbm7kpjo23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163" data-mp="ky3jhnknp7e">
        <div className="flex justify-between items-center h-20" data-id="element-164" data-mp="ej4k9l0e38ju">
          {/* Logo */}
          <a href="#" className="flex flex-col items-center leading-none" data-id="element-165" data-mp="9kb3njpt31fg">
            <span className="text-2xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-166" data-mp="9me2mt8xs4wb">
              VANTIX
            </span>
            <span className="text-[10px] font-normal tracking-[0.3em] text-white/90 border-t border-amber-400 pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-167" data-mp="1kzq97bw2z1m6">
              CREDIT SOLUTIONS
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2" data-id="element-168" data-mp="elzl0p056sof">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-normal text-white/90 hover:text-amber-400 transition-colors" data-id="element-169" data-mp="olqdkl556xlv">
                {link.name}
              </a>)}
          </div>

          {/* CTA */}
          <div className="hidden md:flex items-center" data-id="element-170" data-mp="w5xca0diega">
            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-5 py-2.5 rounded-full transition-all text-sm shadow-lg shadow-amber-500/20" data-id="element-171" data-mp="ul1mh2bopgu">
              Consulta Gratis
              <ArrowRight className="h-4 w-4" data-id="element-172" data-mp="2wc6lwn30udps" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-173" data-mp="3b1mbhzqtgd3w">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white" data-id="element-174" data-mp="3b0bc0c4elril">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-175" data-mp="2id72btud8p0h" /> : <Menu className="h-6 w-6" data-id="element-176" data-mp="2ddudj3jxp7v9" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10" data-id="element-177" data-mp="2s88qamcwnl1h">
          <div className="px-6 pt-6 pb-8 space-y-2 flex flex-col" data-id="element-178" data-mp="7juoz0vg8ld3">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-xl font-medium text-white hover:text-amber-400 transition-colors border-b border-white/10 py-4" data-id="element-179" data-mp="2m2m5bt9neu4">
                {link.name}
              </a>)}
            <div className="pt-6" data-id="element-180" data-mp="166zq6hlhyap">
              <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="w-full flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 text-black font-semibold px-6 py-4 rounded-full text-base" data-id="element-181" data-mp="555zzdsdt6vt">
                Consulta Gratis
                <ArrowRight className="h-4 w-4" data-id="element-182" data-mp="o277b59erj2x" />
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}